import { useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";

const NO_TEMPLATE = "__none__";
// NO_TEMPLATE clears the manual assignment so rule resolution applies again.
const toTemplateId = (selected) => (selected && selected !== NO_TEMPLATE ? selected : null);

/** State + actions for the user detail sheet (template assignment, social toggle). */
export function useUserDetail(user, onClose, onUpdated) {
  const [selectedTemplate, setSelectedTemplate] = useState("");
  const [showSocialMedia, setShowSocialMedia] = useState(true);
  const [savingPrefs, setSavingPrefs] = useState(false);

  useEffect(() => {
    if (!user) return;
    setSelectedTemplate(user.assigned_template_id || NO_TEMPLATE);
    setShowSocialMedia(user.show_social_media !== false);
  }, [user]);

  const toggleSocial = async (checked) => {
    if (!user) return;
    const previous = showSocialMedia;
    setShowSocialMedia(checked);
    setSavingPrefs(true);
    try {
      await api.patch(`/users/${user.id}/preferences`, { show_social_media: checked });
      onUpdated?.(user.id, { show_social_media: checked });
      toast.success(checked ? "Redes sociales activadas" : "Redes sociales ocultas en esta firma");
    } catch (e) {
      setShowSocialMedia(previous);
      toast.error(e?.response?.data?.detail || "No se pudo actualizar la preferencia");
    } finally {
      setSavingPrefs(false);
    }
  };

  const saveAssign = async () => {
    if (!user) return;
    const templateId = toTemplateId(selectedTemplate);
    try {
      await api.post(`/users/${user.id}/assign-template`, { template_id: templateId });
      toast.success(templateId ? "Plantilla asignada" : "Asignación eliminada. Se usarán las reglas.");
      onClose();
      onUpdated?.(user.id, { assigned_template_id: templateId }, { reload: true });
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Error al asignar");
    }
  };

  return {
    selectedTemplate, setSelectedTemplate, showSocialMedia, savingPrefs, toggleSocial, saveAssign, NO_TEMPLATE,
  };
}
